import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

type NumberInputProps = {
    value: number;
    onChange: (value: number) => void;
    width?: string;
    marginTop?: any;
};

const NumberInput: React.FC<NumberInputProps> = ({
    value,
    onChange,
    width,
    marginTop,
}) => {
    const [inputValue, setInputValue] = useState<string>(value.toString());

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let val = event.target.value.replace(',', '.'); // Virgülü noktaya çevir

        // Sadece sayı ve küsüratlı değerlerin kabul edilmesi için regex
        if (/^\d*\.?\d*$/.test(val)) {
            setInputValue(val);

            const numericValue = parseFloat(val);

            // Değerin 0'dan küçük olmaması sağlanır
            if (!isNaN(numericValue) && numericValue >= 0) {
                onChange(numericValue);
            } else if (val === '' || val === '.') { // Boş giriş veya sadece nokta durumu
                onChange(0);
            }
        }
    };

    const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
        event.preventDefault(); // Scroll ile değer değişimini engelle
    };

    return (
        <TextField
            type="text"
            value={inputValue}
            onChange={handleChange}
            onWheel={handleWheel}
            InputProps={{
                inputMode: 'decimal', // Mobil cihazlarda küsürat desteği sağlar
                startAdornment: (
                    <InputAdornment position="start">*</InputAdornment>
                ),
            }}
            sx={{
                marginTop: '1rem',
                alignSelf: 'flex-start',
                width: width,
                marginY: marginTop,
            }}
            className="rounded-md border border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 p-2 w-[150px]"
        />
    );
};

export default NumberInput;
